import { render, staticRenderFns } from "./userHeaderList.vue?vue&type=template&id=4ae80aea&"
import script from "./userHeaderList.vue?vue&type=script&lang=js&"
export * from "./userHeaderList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports